// @flow

import React, { useState } from "react";
import { localize } from "redux-i18n";
import classNames from "classnames";

import type { AbsenceMonitoringLevel } from "@modules/service/reducer/absence-monitoring/types";

type Props = $Exact<{
  level: AbsenceMonitoringLevel,
  onChange: Function,
  disabled?: boolean,
  readonly?: boolean,
  validateName: (name: string) => boolean,
  ...PropsFromLocalize,
}>;

function MonitoringLevelDetails(props: Props) {
  const { level, onChange, disabled, readonly } = props;
  const [nameError, setNameError] = useState(level.name === "");
  const [descriptionError, setDescriptionError] = useState(!level.description);

  function updateName(e: SyntheticEvent<HTMLInputElement>) {
    const next = e.currentTarget.value;
    if (next === level.name) {
      return;
    }

    onChange({ ...level, name: next });

    if (!props.validateName(next)) {
      setNameError(true);
      return;
    }

    setNameError(false);
  }

  function updateDescription(e: SyntheticEvent<HTMLInputElement>) {
    const next = e.currentTarget.value || null;
    if (next === level.description) {
      return;
    }

    onChange({ ...level, description: next });

    if (!next) {
      setDescriptionError(true);
      return;
    }

    setDescriptionError(false);
  }

  return (
    <div className="monitoring-level-details__container">
      <input
        className={classNames("form-control level-name", {
          readonly: readonly,
          error: nameError,
        })}
        placeholder={props.t("ABSENCE_MONITORING_LEVEL_NAME")}
        value={level.name || ""}
        onChange={updateName}
        disabled={disabled}
        readOnly={readonly}
      />
      <textarea
        className={classNames("form-control level-description", {
          readonly: readonly,
          error: descriptionError,
        })}
        placeholder={props.t("ABSENCE_MONITORING_LEVEL_DESCRIPTION")}
        rows="7"
        onChange={updateDescription}
        disabled={disabled}
        readOnly={readonly}
        value={level.description || ""}
      />
    </div>
  );
}

export default localize()(MonitoringLevelDetails);
